import G from '../Global';
import Utils from './Utils';

class Report {
    constructor(config) {
        this.fieldsList  = {};
        this.dimsList = {};
        this.dims = {}
        //设置上报数据
        const effectiveType = window.navigator && window.navigator.connection && window.navigator.connection.effectiveType;
		this.dims.appid = config.APPID.toLowerCase();
		this.dims.platform = 'web';
		this.dims.schema = 'hysignal';
		this.dims.nettype = effectiveType || '';
		this.dims.osver = config.osver || '';
		this.dims.iptype = '0';
		this.dims.device = config.device || '';
		this.dims.sguid = config.guid;
		this.dims.ns_version = G.ver;
		this.dims.ns_compat = '0';
		this.dims.trycount = 1;
		this.dims.prodenv = config.isDebug?"test":"prod";
    }

	setField(id,type,rtime){
		if(id == -1) return;
		this.fieldsList[id] = this.fieldsList[id] || {};
		var fields = this.fieldsList[id];
		fields.ctime =  fields.ctime || Utils.getTime();
		fields.data = fields.data || {};
		let time = rtime || Utils.getTime();
		fields.data[type] = time - fields.ctime;
		if(type == "execute"){
            fields.begintime = time;
		}
		if(type == "execute_end"){
			fields.data["response_time"] =  time - fields.begintime;
		}
		fields.ctime = time;
	}


	getFieldData(id,type){
		if(!this.fieldsList[id]) return {};
		return {...this.fieldsList[id].data};
	}

    setDim(id,type,value){
        this.dimsList[id] = this.dimsList[id] || {...this.dims};
        this.dimsList[id][type] = value;
    }

    getTraceId(id){
        if(this.dimsList[id]){
        	return this.dimsList[id]["traceid"];
        }
        return '';
    }

    getDimData(id){
       if(!this.dimsList[id]) return {};
		return {...this.dimsList[id]};
    }

    clearData(id){
    	delete this.fieldsList[id];
    	delete this.dimsList[id];
    }

    setCommonDim(type,value){
    	this.dims[type] = value;
    }
}

export default Report;

